import { useState, useEffect, useRef } from 'react';
import { useMenuSidebar } from '../../../contexts/MenuSidebarContext';

// Evita acionamento involuntário do menu (ex.: mouse apenas passando perto da
// borda, ou o reflow que o Ctrl+F do navegador provoca sob o cursor parado).
// Só expande/recolhe se o hover permanecer intencional por esse tempo.
const HOVER_EXPAND_DELAY_MS = 300;
const HOVER_COLLAPSE_DELAY_MS = 200;

const useSidebarHook = ({
  menuOpen,
  drawerWidth,
  window,
  departamentoSelecionado,
  onlySmallScreen,
  setDrawerWidth,
  handleDrawerToggle
}) => {
  const container = window !== undefined ? () => window().document.body : undefined;
  const [expanded, setExpanded] = useState(false);
  const [hoverExpandido, setHoverExpandido] = useState(false);
  const hoverTimeoutRef = useRef(null);
  const { mostrarSideBar, setMostrarSideBar, isPendingMenuPrincipal } = useMenuSidebar();
  const menuExpandido = menuOpen || hoverExpandido;

  const limparHoverTimeout = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  };

  useEffect(() => limparHoverTimeout, []);

  const handleChangeAccordion = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    if (!menuExpandido) {
      setExpanded(false);
    }

    setDrawerWidth(menuExpandido ? 354 : onlySmallScreen ? 0 : 70);
  }, [menuExpandido, onlySmallScreen, setDrawerWidth]);

  useEffect(() => {
    document.documentElement.style.setProperty('--drawer-width', `${drawerWidth}px`);
  }, [drawerWidth]);

  useEffect(() => {
    setMostrarSideBar(departamentoSelecionado ? true : false);
  }, [departamentoSelecionado]);

  const handleOnClickFecharMenu = () => {
    if (!isPendingMenuPrincipal) {
      handleDrawerToggle();
    }
  };

  const onMouseEnterSidebar = () => {
    limparHoverTimeout();

    if (menuOpen || onlySmallScreen) {
      return;
    }

    hoverTimeoutRef.current = setTimeout(() => {
      setHoverExpandido(true);
    }, HOVER_EXPAND_DELAY_MS);
  };

  const onMouseLeaveSidebar = () => {
    limparHoverTimeout();

    if (menuOpen) {
      return;
    }

    hoverTimeoutRef.current = setTimeout(() => {
      setHoverExpandido(false);
    }, HOVER_COLLAPSE_DELAY_MS);
  };

  return {
    container,
    expanded,
    setExpanded,
    hoverExpandido,
    menuExpandido,
    mostrarSideBar,
    handleChangeAccordion,
    handleOnClickFecharMenu,
    onMouseEnterSidebar,
    onMouseLeaveSidebar
  };
};

export default useSidebarHook;
